import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-with-image',
  templateUrl: './maintenance-with-image.component.html',
  styleUrls: ['./maintenance-with-image.component.scss']
})
export class MaintenanceWithImageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
